import { Component, OnInit } from '@angular/core';
import { getRhumbLineBearing } from 'geolib';
import { SubProcesosService } from 'src/app/core/services/sub-procesos.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';

enum PerformanceLevel {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

interface LatLngLike {
  lat(): number;
  lng(): number;
}

@Component({
  selector: 'app-brujula',
  templateUrl: './brujula.component.html',
  styleUrls: ['./brujula.component.css']
})
export class BrujulaComponent implements OnInit {

  direction: string = "";
  alpha: number = 0;
  lastAlpha: number = 0;
  private beta: number = 0;
  private gamma: number = 0;
  private accelerationX: number = 0;
  private accelerationY: number = 0;
  private directions = ['Norte', 'Noreste', 'Este', 'Sureste', 'Sur', 'Suroeste', 'Oeste', 'Noroeste'];
  roadType: string = 'Desconocida';
  speed: number = 0;
  latlng: LatLngLike;
  updateCounter = 0;
  lastDirection: any;
  devicePerformance: PerformanceLevel;
  userExperience: string = "beginner";
  rotation = 90;
  verticalRange = 15;
  heading = 0;
  directionByGoogleMaps: string;


  watchGeoId: number;
  private geoErrorShown = false;
  get mode(): string {
    return this.speed > 10 ? "driving" : "walking";
  }

  complexCompass: boolean;
  constructor(private sProcess: SubProcesosService,
    private msg: ToastService) { }


  ngOnInit() {
    setInterval(() => {
      this.detectPerformanceLevel();
    }, 1000);
    this.getDirection();
  }
  ngOnDestroy() {
    navigator.geolocation.clearWatch(this.watchGeoId);
  }

  detectPerformanceLevel() {
    if (navigator.hardwareConcurrency >= 8) {
      this.devicePerformance = PerformanceLevel.High;
    } else {
      this.devicePerformance = PerformanceLevel.Low;
    }

  }


  //#region orientación

  calcAzimut(lat1?:number,lng1?:number,lat2?:number,lng2?:number, heading?: number){
    if(lat1 && lng1 && lat2 && lng2){

      return getRhumbLineBearing(
        {  latitude : lat1 ,  longitude : lng1  } , 
        {  latitude : lat2 ,  longitude : lng2  } 
      ); 
    }else{
      return heading;
    }
  

  }

  gradosARadianes(grados: number) {
    return (grados * Math.PI) / 180;
  }

  // @HostListener('window:deviceorientation', ['$event'])
  // onDeviceOrientation(event: DeviceOrientationEvent) {
  //   this.alpha = event.alpha || 0;
  //   this.beta = event.beta || 0;
  //   this.gamma = event.gamma || 0;
  //   this.updateDirection();
  // }

  // @HostListener('window:devicemotion', ['$event'])
  // async onDeviceMotion(event: DeviceMotionEvent) {
  //   if (event.accelerationIncludingGravity) {
  //     this.accelerationX = event.accelerationIncludingGravity.x || 0;
  //     this.accelerationY = event.accelerationIncludingGravity.y || 0;
  //   }

  //   // Obtener la velocidad actual y el tipo de carretera según tus datos de localización
  //   await this.getCurrentRoadType();
  //   this.updateDirection();

  // }
  // //#endregion




  setGeoLocation(position: GeolocationPosition, heading, direction) {
    this.speed = position.coords.speed;
    this.speed = position.coords.speed * 3.6;
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    this.latlng = window?.google?.maps?.LatLng
      ? new window.google.maps.LatLng(latitude, longitude)
      : {
          lat: () => latitude,
          lng: () => longitude
        };
    this.heading = heading;
    this.direction = direction;
    this.updateDirection();
  }

  getDirection() {
    if (navigator.geolocation) {
      this.watchGeoId = navigator.geolocation.watchPosition(position => {
        this.setGeoLocation(position, this.calcAzimut(position?.coords?.latitude, position?.coords?.longitude, this.latlng?.lat(),this.latlng?.lng(), this.heading), 
        this.calculateDirectionGMAPS(this.heading));
      }, error => {
        if (!this.geoErrorShown) {
          this.geoErrorShown = true;
          this.msg.showError("Error al obtener la dirección:")
          console.log('Error al obtener la dirección:', error);
        }
      }, {
        enableHighAccuracy: true,

      });
    } else {
      this.msg.showError("Geolocalización no soportada en este navegador.")

      console.log('Geolocalización no soportada en este navegador.');
    }
  }

  calculateDirectionGMAPS(heading: number): string {
    if (heading >= 337.5 || heading < 22.5) {
      return 'Norte';
    } else if (heading >= 22.5 && heading < 67.5) {
      return 'Noreste';
    } else if (heading >= 67.5 && heading < 112.5) {
      return 'Este';
    } else if (heading >= 112.5 && heading < 157.5) {
      return 'Sureste';
    } else if (heading >= 157.5 && heading < 202.5) {
      return 'Sur';
    } else if (heading >= 202.5 && heading < 247.5) {
      return 'Suroeste';
    } else if (heading >= 247.5 && heading < 292.5) {
      return 'Oeste';
    } else if (heading >= 292.5 && heading < 337.5) {
      return 'Noroeste';
    } else {
      return 'Desconocida';
    }
  }


  updateDirection() {
    var correctedAlpha = 0;
    if (this.complexCompass) {
      this.calculateDirection(this.alpha);
    }
    else {
      correctedAlpha = this.heading;
    }

    this.sProcess.setGeo({
      lat: this.latlng?.lat(),
      lng: this.latlng?.lng(),
      degrees: correctedAlpha ?? this.alpha,
      velocity: this.speed,
      last: new Date().toLocaleTimeString(),
      direccion: this.direction
    });
  }


  correctAlpha(): number {
    const betaRad = this.beta * (Math.PI / 180);
    const gammaRad = this.gamma * (Math.PI / 180);
    const cosBeta = Math.cos(betaRad);
    const sinGamma = Math.sin(gammaRad);
    let correctedAlpha = this.alpha - this.rotation;
    if (cosBeta !== 0) {
      const tanGamma = sinGamma / cosBeta;
      if (cosBeta > 0 && tanGamma > 0) {
        correctedAlpha += 180;
      } else if (cosBeta < 0 && tanGamma > 0) {
        correctedAlpha += 270;
      } else if (cosBeta < 0 && tanGamma < 0) {
        correctedAlpha += 90;
      }
    } else {
      if (sinGamma > 0) {
        correctedAlpha += 270;
      } else if (sinGamma < 0) {
        correctedAlpha += 90;
      }
    }
    // Ajuste adicional para dispositivos en posición vertical
    const isVertical = Math.abs(window.orientation - 90) <= this.verticalRange;
    if (isVertical) {
      correctedAlpha -= 90;
    }
    return correctedAlpha;
  }

  calculateDirection(alpha: number): string {
    // Ajustar la dirección en función de la velocidad y el tipo de carretera
    let adjustedAlpha = alpha;

    if (this.speed > 50 && this.roadType === 'highway') {
      adjustedAlpha += 180;
    } else if (this.speed < 10 && this.roadType === 'city') {
      adjustedAlpha -= 45;
    }
    // Ajustar la dirección en función de la aceleraciónX (si está hacia arriba o hacia abajo)
    if (this.accelerationX > 30) {
      adjustedAlpha -= 45;
    } else if (this.accelerationX < -30) {
      adjustedAlpha += 45;
    }

    // Ajustar la dirección en función de la aceleraciónY (si está mirando al usuario o al revés)
    if (this.accelerationY > 10) {
      adjustedAlpha += 90;
    } else if (this.accelerationY < -10) {
      adjustedAlpha -= 90;
    }
    // Limitar la velocidad de giro para dispositivos menos potentes
    if (this.devicePerformance == PerformanceLevel.Low || PerformanceLevel.Medium) {
      adjustedAlpha = adjustedAlpha % 360;
    }

    // Limitar la velocidad de actualización para usuarios con poca experiencia o en modo de caminata
    if (this.userExperience === 'beginner' || this.mode === 'walking') {
      if (this.updateCounter % 15 !== 0) {
        this.updateCounter = 0;
        this.alpha = this.lastAlpha;
        return this.lastDirection;
      }
    }
    this.alpha = adjustedAlpha;
    this.lastAlpha = adjustedAlpha;
    const index = Math.round(adjustedAlpha / 45) % 8;
    this.lastDirection = this.directions[index];
    this.updateCounter++;
    return this.directions[index];
  }


  getRoadTypeFromAddressComponents(addressComponents: any[]): string {
    // Implementa aquí la lógica para determinar el tipo de carretera a partir de los componentes de dirección
    const highwayKeywords = ['highway', 'freeway', 'motorway'];
    const cityKeywords = ['street', 'avenue', 'road', 'lane'];

    const routeComponent = addressComponents.find(component =>
      component.types.includes('route')
    );
    if (routeComponent) {
      const routeName = routeComponent.long_name.toLowerCase();
      if (this.containsAnyKeyword(routeName, highwayKeywords)) {
        return 'highway';
      } else if (this.containsAnyKeyword(routeName, cityKeywords)) {
        return 'city';
      }
    }

    return 'unknown';
  }

  containsAnyKeyword(text: string, keywords: string[]): boolean {
    for (const keyword of keywords) {
      if (text.includes(keyword)) {
        return true;
      }
    }
    return false;
  }

}
